'use client';

import { createContext } from 'react';

import { User } from '../models/user.model';

export interface AuthenticationContextValue {
   loading: boolean;
   user: User | undefined;
   accessToken: string | undefined;
   refreshToken: () => Promise<void>;
   login: (redirectUrl?: string) => void;
   logout: () => void;
}

export const AuthenticationContext = createContext<AuthenticationContextValue | null>(null);
